// SPDX-License-Identifier: AGPL-3.0-or-later
import { daysBetween } from "./dates.js";
export const DEFAULT_THRESHOLDS = { green: 0.9, amber: 1 };
/**
 * Traffic-light status for spending against a budget, prorated to `today`.
 * On the 10th of a 30-day month, a third of the budget is expected to be
 * spent. Today counts as a full day so the first day is not judged on $0.
 */
export function paceStatus(spent, budget, range, today, thresholds = DEFAULT_THRESHOLDS) {
    const elapsed = Math.min(range.days, Math.max(1, daysBetween(range.start, today) + 1));
    const paced = Math.round((budget * elapsed) / range.days);
    const ratio = paced > 0 ? spent / paced : spent > 0 ? Infinity : 0;
    const light = ratio <= thresholds.green ? "green" : ratio <= thresholds.amber ? "amber" : "red";
    return { light, paced, spent, ratio };
}
//# sourceMappingURL=status.js.map